export default function({ store }) {
 	return store.dispatch('placement/getPlacementList');
}